import { z } from 'zod';
import { EventType } from './events.js';
import { SCHEMA_VERSION } from './session.js';
/**
 * Runtime validation for the collector's hot path. Intentionally shallow on the
 * `events[].data` payloads — full structural validation of every rrweb event
 * would cost too much per request; we validate the envelope and event framing,
 * then trust the recorder for inner shapes (it is our own code).
 */
const replayEventSchema = z.object({
    type: z.nativeEnum(EventType),
    timestamp: z.number().int().nonnegative(),
    data: z.unknown(),
});
const deviceSchema = z.object({
    browser: z.string(),
    browserVersion: z.string(),
    os: z.string(),
    osVersion: z.string(),
    deviceType: z.enum(['desktop', 'mobile', 'tablet', 'unknown']),
    userAgent: z.string().max(1024),
    platform: z.enum(['web', 'ios', 'android']).optional(),
});
const sessionMetaSchema = z.object({
    entryUrl: z.string().url().max(2048),
    currentUrl: z.string().url().max(2048),
    referrer: z.string().max(2048),
    device: deviceSchema,
    // Dimensions are non-negative (not strictly positive): a transient 0×0
    // viewport from a backgrounded/unlaid-out tab must NOT reject the batch —
    // that would discard the irreplaceable DOM snapshot over cosmetic metadata.
    screen: z.object({
        width: z.number().int().nonnegative(),
        height: z.number().int().nonnegative(),
        dpr: z.number().nonnegative(),
    }),
    language: z.string().max(35),
    timezone: z.string().max(64),
    environment: z.enum(['production', 'staging', 'development']),
    releaseVersion: z.string().max(128).optional(),
    sdkVersion: z.string().max(32),
});
export const eventBatchSchema = z.object({
    v: z.literal(SCHEMA_VERSION),
    projectId: z.string().min(1).max(64),
    sessionId: z.string().uuid(),
    seq: z.number().int().nonnegative(),
    anonymousId: z.string().min(1).max(64),
    userId: z.string().max(256).optional(),
    userTraits: z.record(z.unknown()).optional(),
    events: z.array(replayEventSchema).min(1).max(5000),
    meta: sessionMetaSchema,
    sentAt: z.number().int().nonnegative(),
});
//# sourceMappingURL=validators.js.map